module.exports = __webpack_public_path__ + "static/media/998390.c471f3dd.png";